export const DEFAULT_DROPDOWN_CONFIG: any = {
  highlight: false,
  create: false,
  persist: true,
  plugins: ["dropdown_direction", "remove_button"],
  dropdownDirection: "down"
};
export const ASYNC_DROPDOWN_CONFIG = Object.assign(
  {},
  DEFAULT_DROPDOWN_CONFIG,
  {
    labelField: "label",
    valueField: "value",
    classes: ["destination", "destination-from", "icon-geolocation"],
    searchField: ["label", "value"]
  }
);
export const SingleSelectConfig: any = Object.assign(
  {},
  DEFAULT_DROPDOWN_CONFIG,
  {
    labelField: "label",
    valueField: "value",
    plugins: ["remove_button"],
    maxItems: 1
  }
);
export const DEFAULT_VALUE_TIMEOUT = 1;
export const DEFAULT_OPTIONS_TIMEOUT = 2;



// WEBPACK FOOTER //
// /Neptune/buildsJenkins/lrm_grandPublic/LRM-GP/LrGrandPublic/src/main/LRM-web/src/app/offrecommerciale/simplesearch/asyncConfig.config.ts